import React, { useMemo } from "react"
import { ReactSVG } from "react-svg"
import useLinks from "@hooks/useLinks"
import useWindowDimensions from "@hooks/useWindowDimensions"
import {
  IMPRESSIT_SOCIAL_MEDIAS,
  NAVIGATIONAL_ITEMS,
} from "../../constants"
import {
  StyledNavigationalLinksContainer,
  StyledNavigationalLinkContainer,
  StyledNavigationalLinksBlockTitle,
  StyledSocialMediaItemContainer,
  StyledSocialMediaItem
} from "../../components/Footer/styled"

const useFooterConfiguration = () => {
  const generateLinks = useLinks()
  const { isMobile } = useWindowDimensions()
  const currentYear = new Date().getFullYear()

  const socialMedias = IMPRESSIT_SOCIAL_MEDIAS.map(({ link, ariaLabel, icon }) => (
    <StyledSocialMediaItemContainer aria-label={ariaLabel} href={link} target="_blank" key={link} rel="noreferrer">
      <StyledSocialMediaItem src={icon} />
    </StyledSocialMediaItemContainer>
  ))

  const navigationalItems = useMemo(() => NAVIGATIONAL_ITEMS.map(({ items }) => (
    <StyledNavigationalLinksContainer>
      {items.map(({ title, navigationLinks }) => (
        <StyledNavigationalLinkContainer key={title}>
          <StyledNavigationalLinksBlockTitle>
            {title}
          </StyledNavigationalLinksBlockTitle>
          {generateLinks(navigationLinks)}
        </StyledNavigationalLinkContainer>
      ))}
    </StyledNavigationalLinksContainer>
  )), [])

  return {
    isMobile,
    socialMedias,
    navigationalItems,
    currentYear
  }
}

export default useFooterConfiguration
